<template>
  <v-dialog width="700px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Adicionar multa ou avaria</strong>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-col>
            <BuscaUsuario @selectUser="selectUser"></BuscaUsuario>
          </v-col>
          <v-divider></v-divider>
          <v-row>
            <v-col md12>
              <label for="model">Valor:</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <money
                  v-bind="money"
                  v-model="valor"
                  class="form-control"
                ></money>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md6>
              <v-select
                :rules="[v => !!v || 'É necessário selecionar um Tipo.']"
                v-model="tipoSelected"
                :items="tipos"
                item-text="text"
                item-value="value"
                label="Tipo:"
                required
              >
              </v-select>
            </v-col>
            <v-col md6>
              <v-text-field
                :rules="[
                  v => !!v || 'É necessário adicionar uma reserva.',
                  v => v.length <= 6 || 'Máximo 6 characters',
                ]"
                counter="6"
                v-model="reservaId"
                type="number"
                label="Reserva ID"
                required
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-autocomplete
              v-if="tipoSelected=='breakdown'"
              v-model="breakdown_id"
              :items="dataForCharge"
              item-value="id"
              item-text="text"
              label="Sinistro/Manutenção"
              prepend-icon="mdi-magnify"
            ></v-autocomplete>
          </v-row>
          <v-row>
            <v-col md12>
              <v-textarea
                v-model="description"
                label="Descrição:"
                required
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn color="error" class="mr-4" @click="reset">
            Cancelar
          </v-btn>

          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="salvar"
          >
            Salvar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import BuscaUsuario from '../shared/BuscaUsuario.vue';
import NumberHelper from '../../helpers/NumberHelper';
import TransactionController from '../../controllers/TransactionController';
import BreakdownController from '../../controllers/BreakdownController';
export default {
  components: {
    BuscaUsuario,
  },
  props: {
    showModal: Boolean,
  },
  data() {
    return {
      transactionController: new TransactionController(this.$resource),
      breakdownController: new BreakdownController(this.$resource),
      tipos: [
        { value: 'mulct', text: 'Multa' },
        { value: 'breakdown', text: 'Avaria' },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      user: {},
      tipoSelected: null,
      valor: 0,
      reservaId: null,
      valid: true,
      description: '',
      dataForCharge: [],
      breakdown_id: null
    };
  },
  created() {
    this.getDataForCharge();
  },
  // watch: {
  //   recurrent: function() {
  //     this.getUserCreditCard();
  //   },
  // },

  methods: {
    selectUser(selectUser) {
       this.user = selectUser;
    },
    salvar() {
      this.$refs.form.validate();
      let valor = NumberHelper.convertMoneyToInteger(this.valor);
      if (valor == 0) {
        return this.$awn.alert('Valor inválido!');
      }
      if (!this.user.id) {
        return this.$awn.alert('Usuário inválido!');
      }
      this.transactionController
        .postMulctsAndBreakdownsPending({
          vehicle_request_id: this.reservaId,
          type: this.tipoSelected,
          user_id: this.user.id,
          value: valor,
          description: this.description,
          breakdown_id: this.breakdown_id
        })
        .then(res => {
          this.$awn.success('Cadastro efetuado com sucesso!');
          this.$refs.form.reset();
          this.$emit('btnSim');
        })
        .catch(error => {
          this.$awn.alert('Erro ao cadastrar multa!');
          console.log(error);
        });        
    },
    getDataForCharge(){
      this.breakdownController
        .getDataForCharge()
        .then(
          response => {
            if (response.body.length > 0) {
              response.body.forEach(element => {
                this.dataForCharge.push({ id: element.id , text: `${element.description} - ${element.model}-${element.plate} - ${element.name}`})
              });              
            }            
          },
          err => console.log(err)
        );
    },    
    reset() {
      this.valor = 0;
      this.$refs.form.reset();
      this.$emit('btnNao');
    },
  },
};
</script>
